import BaseService from './_base.service';

export const weightService = {
    page,
    edit,
    search,
    combo,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/lens/attr/weight/page/"+page+"/"+size, callback, true)
}

function combo(callback) {
    return BaseService.get("/lens/attr/weight/combo/", callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/lens/attr/weight/page/"+page+"/"+size,filter, callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/lens/attr/weight/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/lens/attr/weight/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/lens/attr/weight/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/lens/attr/weight/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/lens/attr/weight/"+id+"/logic", callback);
}
